import React, { useEffect, useState } from "react";
import { Button, Card, Divider } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import useFirmService from "../../../../services/useFirmService";
import { Modal, Upload, message, Spin } from "antd";
import { InboxOutlined } from "@ant-design/icons";

const { Dragger } = Upload;

const CustomImageUploadModal = ({
  visible,
  onClose,
  onSuccess,
  currentImageUrl,
}) => {
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const { useUploadFirmImage } = useFirmService();
  const { mutateAsync: uploadFirmImage, isPending: isImageUploadLoading } =
    useUploadFirmImage();

  const beforeUpload = (file) => {
    const isImage = file.type.startsWith("image/");
    if (!isImage) {
      message.error("Sadece Fotoğraf Tipinde Dosya Yükleyebilirsiniz");
      return false;
    }

    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      message.error("Fotoğraf 5MB'dan küçük olmalıdır!");
      return false;
    }
    return true;
  };

  const handleUpload = async () => {
    if (fileList.length === 0) return;

    try {
      setUploading(true);
      await uploadFirmImage(fileList[0].originFileObj);
      setFileList([]);
      onSuccess?.();
      onClose();
      message.success("Fotoğraf başarıyla yüklendi");
    } catch (error) {
    } finally {
      setUploading(false);
    }
  };

  const handleRemove = () => {
    setFileList([]);
  };

  const uploadProps = {
    beforeUpload,
    fileList,
    onChange: ({ fileList: newFileList }) => {
      setFileList(newFileList);
    },
    onRemove: handleRemove,
    maxCount: 1,
    multiple: false,
    showUploadList: false,
    accept: "image/*",
  };

  return (
    <Modal
      title="Şirket Fotoğrafını Yükle"
      open={visible}
      onCancel={onClose}
      width={600}
      footer={[
        <Button key="cancel" onClick={onClose}>
          İptal
        </Button>,
        <Button
          key="upload"
          type="primary"
          onClick={handleUpload}
          disabled={fileList.length === 0}
          loading={uploading}
          style={{
            border: "none",
          }}>
          Kaydet
        </Button>,
      ]}>
      <div>
        {/* Current Image Section */}
        {currentImageUrl && (
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <div
              style={{
                width: "150px",
                height: "150px",
                margin: "0 auto 16px auto",
                borderRadius: "8px",
                overflow: "hidden",
              }}>
              <img
                src={currentImageUrl}
                alt="Current Company Logo"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </div>
          </div>
        )}

        <Divider />

        {/* Upload Section */}
        <div style={{ position: "relative" }}>
          <Dragger {...uploadProps} style={{ padding: "20px" }}>
            {fileList.length > 0 ? (
              <div
                style={{
                  position: "relative",
                  width: "250px",
                  height: "250px",
                  margin: "0 auto",
                }}>
                <img
                  src={URL.createObjectURL(fileList[0].originFileObj)}
                  alt="New Company Logo"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: "8px",
                  }}
                />
              </div>
            ) : (
              <div>
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">Buraya sürükle ya da Yükle</p>
                <p className="ant-upload-hint" style={{ color: "#6b7280" }}>
                  Fotoğrafın en fazla 5MB büyüklüğünde olmalıdır.
                </p>
              </div>
            )}
          </Dragger>
        </div>
      </div>
    </Modal>
  );
};

const FirmImage = ({ imageUrl }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleModalSuccess = () => {
    setIsModalVisible(false);
  };

  return (
    <Card
      title="Şirket Fotoğrafını Güncelle"
      style={{ maxWidth: 1000, margin: "auto", marginTop: 20 }}
      headStyle={{ textAlign: "center" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "20px",
        }}>
        {/* Display current image */}
        {imageUrl && (
          <div
            style={{
              width: "200px",
              height: "200px",
              borderRadius: "8px",
              overflow: "hidden",
              border: "1px solid #e8e8e8",
            }}>
            <img
              src={imageUrl}
              alt="Company Logo"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </div>
        )}

        <Button
          type="primary"
          icon={<UploadOutlined />}
          onClick={() => setIsModalVisible(true)}
          style={{ width: "200px" }}>
          {imageUrl ? "Fotoğrafı Güncelle" : "Şirket Fotoğrafı Yükle"}
        </Button>
      </div>

      <CustomImageUploadModal
        visible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        onSuccess={handleModalSuccess}
        currentImageUrl={imageUrl}
      />
    </Card>
  );
};

export default FirmImage;
